import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=4d65d08d&scoped=true&"
import script from "./CardList.vue?vue&type=script&lang=js&"
export * from "./CardList.vue?vue&type=script&lang=js&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=4d65d08d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65d08d",
  null
  
)

export default component.exports